(function () {
  'use strict';

  function initStepCarousel(section) {
    var list = section.querySelector('[data-step-carousel]');
    var dots = Array.from(section.querySelectorAll('[data-step-dot]'));
    var items = Array.from(section.querySelectorAll('[data-step-index]'));

    if (!list || items.length === 0) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var scrollBehavior = prefersReduced ? 'instant' : 'smooth';

    function scrollToItem(index) {
      var target = items[index];
      if (!target) return;
      target.scrollIntoView({ behavior: scrollBehavior, block: 'nearest', inline: 'center' });
    }

    function setActiveDot(index) {
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.setAttribute('aria-current', active ? 'true' : 'false');
        dot.classList.toggle('pdp-steps__dot--active', active);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        scrollToItem(parseInt(dot.dataset.stepDot, 10));
      });
    });

    items.forEach(function (item) {
      item.addEventListener('focusin', function () {
        item.scrollIntoView({ behavior: scrollBehavior, block: 'nearest', inline: 'center' });
      });
    });

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            setActiveDot(parseInt(entry.target.dataset.stepIndex, 10));
          }
        });
      },
      { root: list, threshold: 0.5 }
    );

    items.forEach(function (item) { observer.observe(item); });
  }

  function init() {
    if (window.innerWidth >= 750) return;
    document.querySelectorAll('.pdp-steps').forEach(function (section) {
      initStepCarousel(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
